export default "__VITE_ASSET__Dc9YGKKk__"